import React from 'react';
import notFound from '../../assets/img/404.png';
import styled from 'styled-components';

const PageNotFound = () => {
  return (
    <NotFoundArea>
      <img src={notFound} />
      <h3>Página não encontrada</h3>
    </NotFoundArea>
  );
};

const NotFoundArea = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 160px;
  img {
    width: 25%;
  }
  h3 {
    margin-top: 25px;
    font-size: 30px;
  }
`;

export default PageNotFound;
